import React, { useEffect, useMemo, useState } from 'react';
import feather from 'feather-icons';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { FiHelpCircle, FiSearch, FiX } from 'react-icons/fi';
import '../styles/HelpCenterPage.css';

function HelpCenter() {
    const { t } = useLanguage();
    const [query, setQuery] = useState('');

    useEffect(() => {
        feather.replace();
    }, [query]);

    const faqs = useMemo(
        () =>
            Array.from({ length: 9 }, (_, i) => i + 1).map((n) => ({
                key: String(n - 1),
                title: t(`faq${n}Title`),
                body: t(`faq${n}Body`),
            })),
        [t]
    );

    const filteredFaqs = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return faqs;
        return faqs.filter(
            (faq) => faq.title.toLowerCase().includes(q) || faq.body.toLowerCase().includes(q)
        );
    }, [faqs, query]);

    return (
        <div className="help-center-page">
            {/* Header */}
            <header className="section-t-space">
                <div className="custom-container">
                    <div className="header-panel">
                        <Link to="/profile" className="back-btn">
                            <i className="icon" data-feather="arrow-left"></i>
                        </Link>
                        <h2>{t('helpCenter')}</h2>
                    </div>
                </div>
            </header>

            {/* Content */}
            <section>
                <div className="custom-container">
                    {/* Hero */}
                    <div className="hc-hero">
                        <div className="hc-hero-icon">
                            <FiHelpCircle />
                        </div>
                        <p className="hc-hero-subtitle">{t('helpCenterSubtitle')}</p>
                    </div>

                    {/* Search */}
                    <div className="hc-search">
                        <FiSearch className="hc-search-icon" />
                        <input
                            type="text"
                            className="hc-search-input"
                            placeholder={t('searchFaqPlaceholder')}
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                        {query && (
                            <button
                                type="button"
                                className="hc-search-clear"
                                onClick={() => setQuery('')}
                                aria-label={t('clearSearch')}
                            >
                                <FiX />
                            </button>
                        )}
                    </div>

                    <div className="hc-section-label">
                        {t('whatIssuesAreFacing')}
                        <span className="hc-count">
                            {filteredFaqs.length} {t('faqCount')}
                        </span>
                    </div>

                    {filteredFaqs.length > 0 ? (
                        <Accordion defaultActiveKey="0" className="help-accordion hc-accordion">
                            {filteredFaqs.map((faq) => (
                                <Accordion.Item eventKey={faq.key} key={faq.key}>
                                    <Accordion.Header>{faq.title}</Accordion.Header>
                                    <Accordion.Body>{faq.body}</Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <div className="hc-empty">
                            <div className="hc-empty-icon">
                                <FiSearch />
                            </div>
                            <h4>{t('noFaqFound')}</h4>
                            <p>{t('noFaqFoundHint')}</p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default HelpCenter;
